import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddPunchoutParameter, addPunchoutSecret } from "@TKCCP/Services/tkccpPunchoutService";
import { PunchoutServiceModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    AddPunchoutParameter,
    PunchoutServiceModel,
    { punchoutServiceModel: PunchoutServiceModel }
>;

export const AddPunchoutSecret = (model: AddPunchoutParameter) => {
    try {
        const result = addPunchoutSecret(model);
        // eslint-disable-next-line no-empty
    } catch (error) {}
};
